import PropTypes from 'prop-types';
import warning from 'tiny-warning';
import { SWAN_ICON_KEY_MAP, getSwanIconUrl } from '../../../core/utilities/manifest-icons.utils.js';
import { useSwanContext } from '../../contexts/swan-provider/swan-provider.context.js';
import { createComponent } from '../core/create-component.js';
import { swanStyleObjectFitValues, swanStyleObjectFit } from '../../../core/utilities/swan-style.utils.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const IconsNoStandardSkin = [
    'shoppingBag_1',
    'shoppingBag_2',
    'shoppingBag_3',
    'shoppingBag_4',
    'shoppingBag_5',
    'shoppingBag_6',
    'shoppingBag_7',
    'shoppingBag_8',
    'shoppingBag_9',
    'shoppingBag_10',
    'shoppingBag_11',
    'shoppingBag_12',
    'shoppingBag_13',
    'shoppingBag_14',
    'shoppingBag_50'
];
const propTypes = {
    iconType: PropTypes.oneOf(Object.keys(SWAN_ICON_KEY_MAP)),
    size: PropTypes.oneOf([
        '10p',
        '16p',
        '20p',
        '24p',
        '28p',
        '32p',
        '40p',
        '48p',
        '60p'
    ]),
    skin: PropTypes.oneOf([
        'standard',
        'brand-blue',
        'white',
        'error'
    ]),
    objectFit: PropTypes.oneOf(swanStyleObjectFitValues)
};
const Icon = createComponent({
    displayName: 'Icon',
    root: 'img',
    propTypes,
    propConfig: {
        derivedProps (props) {
            const { swanPathType , swanBaseUrl  } = useSwanContext();
            const isCustom = !!props.src;
            warning(!(!props.src && !props.iconType), 'Icon: Both iconType and src prop are missing. Provide at least one of them.');
            const src = props.src || props.iconType && getSwanIconUrl(props.iconType, swanPathType, swanBaseUrl) || undefined;
            return {
                src,
                isCustom
            };
        },
        processProps (props, derivedProps) {
            return _object_spread_props(_object_spread({}, props), {
                // role: props.role || !props.alt ? 'presentation' : undefined,
                src: derivedProps.src || undefined,
                alt: props.alt || ''
            });
        },
        classNames ({ size , skin ='standard' , iconType , objectFit  }, derivedProps) {
            const classNames = [
                'swan-icon'
            ];
            const objectFitClassName = swanStyleObjectFit(objectFit);
            if (objectFitClassName) classNames.push(objectFitClassName);
            if (skin === 'standard' && iconType && IconsNoStandardSkin.includes(iconType)) skin = null;
            if (size) classNames.push(`swan-icon-size-${size}`);
            if (skin) classNames.push(`swan-icon-skin-${skin}`);
            if (derivedProps.isCustom) {
                classNames.push('swan-icon-custom');
            } else {
                classNames.push(`swan-icon-type-${iconType}`);
            }
            return classNames;
        }
    }
});

export { Icon, IconsNoStandardSkin };
